import { createStore, applyMiddleware } from "redux";
import rootReducer from "./rootReducer";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const middleWares = [thunk];

const store = createStore(
  persistedReducer,
  undefined,
  applyMiddleware(...middleWares)
);
let persistor = persistStore(store);

export { store, persistor };
